import type { TranslationKeys } from '../types';

const th: TranslationKeys = {
  nav: {
    home: 'หน้าแรก',
    blockExplorer: 'ตัวสำรวจ',
    swap: 'แลกเปลี่ยน',
    exchange: 'แลกเปลี่ยนข้ามเชน',
    docs: 'เอกสาร',
    more: 'เพิ่มเติม',
    close: 'ปิด',
    bridge: 'บริดจ์',
  },
  bridge: {
    title: 'บริดจ์ Igra',
    subtitle: 'บริดจ์ KAS ระหว่าง Kaspa และ Igra (เชน {chainId})',
    tabDeposit: 'ฝาก KAS',
    tabDepositSub: 'KAS → iKAS',
    tabWithdraw: 'ถอน KAS',
    tabWithdrawSub: 'iKAS → KAS',
    chainKaspa: 'Kaspa',
    chainEvm: 'EVM (Igra)',
    useWallet: 'ใช้วอลเล็ต',
    gate: {
      installTitle: 'เชื่อมต่อ KasWare',
      installDesc:
        'ธุรกรรมบริดจ์ทั้งหมดลงนามภายใน KasWare ติดตั้งส่วนขยายหรือเปิดหน้านี้ในแอป Telegram ของ KasWare',
      disconnectedTitle: 'วอลเล็ตตัดการเชื่อมต่อ',
      connectWallet: 'เชื่อมต่อวอลเล็ต',
      connectTitle: 'เชื่อมต่อ {chain}',
      connectDesc: 'อนุญาตบัญชี {chain} ใน KasWare เพื่อดำเนินการต่อ',
      connecting: 'กำลังเชื่อมต่อ...',
      connectChain: 'เชื่อมต่อ {chain}',
    },
    deposit: {
      youSend: 'คุณส่ง (Kaspa L1)',
      youReceive: 'คุณได้รับ (Igra L2)',
      recipientLabel: 'รับ iKAS ที่ที่อยู่ Igra นี้',
      fromWallet: '(จากวอลเล็ต)',
      badAddress: 'กรุณากรอกที่อยู่ EVM ที่ถูกต้อง — ที่อยู่ที่มีตัวพิมพ์ใหญ่ต้องผ่านการตรวจเช็คซัม EIP-55',
      connectEvm: 'เชื่อมต่อ EVM เพื่อกรอกอัตโนมัติ',
      connectingEvm: 'กำลังเชื่อมต่อ EVM...',
      infoMin: 'ฝากขั้นต่ำ: {min} KAS',
      infoMining:
        'ระบบจะขุดธุรกรรม ID ในเบราว์เซอร์ของคุณให้ขึ้นต้นด้วย 97b1 ซึ่งโดยปกติใช้เวลาไม่กี่วินาที',
      infoMint: 'iKAS จะถูกสร้างหลังจาก sequencer ของ Igra ยืนยัน Entry บน Kaspa แล้ว',
      phaseConnecting: 'กำลังเชื่อมต่อเครือข่าย Kaspa...',
      phaseFetching: 'กำลังดึง UTXO ของคุณ...',
      phaseMining: 'กำลังขุดธุรกรรม ID ที่ถูกต้อง... ({tries} ครั้ง)',
      phaseSigning: 'กำลังรอลายเซ็นของคุณใน KasWare...',
      phaseBroadcasting: 'กำลังกระจายธุรกรรม Entry...',
      cancelMining: 'ยกเลิกการขุด',
      successTitle: 'ส่งคำขอฝากแล้ว',
      successMined: 'พบธุรกรรม ID ที่ถูกต้องหลังจากลอง {tries} ครั้ง (nonce {nonce})',
      kaspaTx: 'ธุรกรรม Kaspa:',
      prefixWarning:
        'ธุรกรรม ID ที่กระจายแล้วไม่ได้ขึ้นต้นด้วย 97b1 อีกต่อไป Igra อาจไม่เข้ายอดการฝากนี้ — โปรดเก็บธุรกรรม ID ไว้และติดต่อฝ่ายสนับสนุน',
      newDeposit: 'ฝากใหม่',
      cta: 'บริดจ์ KAS ไป Igra',
      ctaAmount: 'บริดจ์ {amount} KAS ไป Igra',
    },
    withdraw: {
      youBurn: 'คุณเบิร์น (Igra L2)',
      paidOut: 'จ่ายออกบน (Kaspa L1)',
      payoutLabel: 'ที่อยู่รับ KAS',
      infoLimits: 'ขีดจำกัด: {min} – {max} iKAS ต่อการถอน',
      infoFeeZero: 'ค่าธรรมเนียมโปรโตคอล: ปัจจุบันเป็น 0',
      infoFeeQuoted: 'ค่าธรรมเนียมโปรโตคอล: จะแจ้งราคาตอนทำรายการ',
      infoRate: '1 iKAS เบิร์นได้รับการจ่ายออกเป็น 1 KAS พอดี (ไม่มีส่วนต่าง)',
      warningPrefix: 'การถอน',
      warningStrong: 'ไม่ใช่แบบทันที',
      warningRest:
        'iKAS จะถูกเบิร์นบน Igra จากนั้นคณะกรรมการมัลติซิกจะปล่อย KAS บน Kaspa หลังตรวจสอบคำขอ โปรดส่งเฉพาะจำนวนที่คุณพร้อมจะรอ',
      checking: 'กำลังตรวจสอบ...',
      modalTitle: 'ยืนยันการถอน',
      modalBurn: 'คุณเบิร์น',
      modalFee: 'ค่าธรรมเนียมโปรโตคอล',
      modalPayout: 'KAS จ่ายไปยัง',
      modalAck: 'ฉันเข้าใจว่าการจ่ายเงินเป็นแบบแมนนวล ตรวจสอบโดยคณะกรรมการมัลติซิก และไม่ใช่แบบทันที',
      modalConfirm: 'ยืนยันและเบิร์น iKAS',
      modalBack: 'กลับ',
      successTitle: 'คำขอถอนได้รับการยืนยันบน Igra แล้ว',
      requestId: 'ID คำขอถอน: {id}',
      igraTx: 'ธุรกรรม Igra:',
      successPayout: 'KAS จะถูกส่งไปยัง:',
      successNote: 'KAS จะถูกจ่ายไปยังที่อยู่รับของคุณหลังการตรวจสอบมัลติซิก',
      newWithdrawal: 'ถอนใหม่',
      requesting: 'กำลังส่งคำขอถอน...',
      cta: 'เบิร์น iKAS และขอ KAS',
      ctaAmount: 'เบิร์น {amount} iKAS และขอ KAS',
    },
  },
  home: {
    tagline: 'KasWare Wallet',
    hero: {
      subtitle: 'กระเป๋าเงินเดียวที่ดูแลกุญแจด้วยตัวเอง รองรับ TON, Kaspa และเชน EVM — กุญแจอยู่บนอุปกรณ์ของคุณเสมอ',
      chainsLabel: 'เครือข่ายที่รองรับ',
      ctaDownload: 'เพิ่มใน Chrome',
      ctaTelegram: 'เปิดใน Telegram',
      note: 'ใช้ฟรี ไม่ต้องสมัคร ไม่ต้องใช้อีเมล',
    },
    pillars: {
      security: {
        title: 'ปลอดภัยตั้งแต่การออกแบบ',
        desc: 'กุญแจถูกสร้างและเข้ารหัสบนอุปกรณ์ของคุณ ทุกธุรกรรมจะถูกตรวจความเสี่ยงและแสดงรายละเอียดครบก่อนลงนาม',
      },
      convenience: {
        title: 'ครบในที่เดียว',
        desc: 'เก็บ ส่ง แลกเปลี่ยน และข้ามเชนระหว่าง TON, Kaspa และ EVM โดยไม่ต้องสลับหลายกระเป๋า',
      },
      friendly: {
        title: 'ออกแบบเพื่อผู้ใช้จริง',
        desc: 'ข้อความอธิบายเข้าใจง่าย ที่อยู่อ่านชัด มีธีมสว่างและมืด พร้อมเจ็ดภาษา',
      },
      reliable: {
        title: 'พึ่งพาได้',
        desc: 'ประวัติธุรกรรมตรวจสอบได้ มีหลายจุดเชื่อมต่อเครือข่าย และยังใช้งานได้เมื่อผู้ให้บริการรายหนึ่งล่ม',
      },
    },
    content: {
      downloadTitle: 'ดาวน์โหลด',
      securityTitle: 'ทำไมเงินของคุณยังเป็นของคุณ',
      p1: 'KasWare เป็นกระเป๋าเงินแบบดูแลกุญแจด้วยตัวเองสำหรับ Ton, Kaspa และ EVM',
      p2: 'เราไม่สามารถเข้าถึงเงินทุนของคุณได้ คีย์ส่วนตัวของคุณถูกเข้ารหัสบนอุปกรณ์ของคุณด้วยรหัสผ่านและไม่ถูกแชร์กับใคร',
      p3: 'บัญชีทั้งหมดถูกสร้างแบบกำหนดจากวลีการกู้คืนลับของคุณ ให้คุณเป็นเจ้าของและควบคุมอย่างเต็มที่',
    },
  },
  about: {
    contact: 'ติดต่อเรา',
    contacts: {
      twitter: 'Twitter',
      telegram: 'Telegram',
      discord: 'Discord',
      email: 'อีเมล',
    },
  },
  footer: {
    privacy: 'นโยบายความเป็นส่วนตัว',
    copyright: '© {year} Flying Rabbit Tech Ltd',
  },
  explorer: {
    title: 'ตัวสำรวจธุรกรรม',
    subtitle: 'ค้นหาบันทึกธุรกรรม Kaspa และ KRC-20 ตามที่อยู่',
    timeRange: 'ช่วงเวลา:',
    to: 'ถึง',
    clear: 'ล้าง',
    address: 'ที่อยู่:',
    kasTab: 'การโอน KAS',
    krc20Tab: 'การดำเนินงาน KRC-20',
    enterAddress: 'ป้อนที่อยู่ Kaspa เพื่อดูธุรกรรม',
    loading: 'กำลังโหลด...',
    search: {
      placeholder: 'ป้อนที่อยู่ Kaspa (kaspa:q...)',
      button: 'ค้นหา',
    },
    tx: {
      loading: 'กำลังโหลดธุรกรรม...',
      empty: 'ไม่พบธุรกรรมสำหรับที่อยู่นี้',
      emptyInRange: 'ไม่พบธุรกรรมสำหรับที่อยู่นี้ในช่วงเวลาที่เลือก',
      failed: 'ไม่สามารถโหลดธุรกรรมได้: {error}',
      retry: 'ลองอีกครั้ง',
    },
    krc20: {
      loading: 'กำลังโหลดการดำเนินงาน KRC-20...',
      empty: 'ไม่พบการดำเนินงาน KRC-20 สำหรับที่อยู่นี้',
      emptyInRange: 'ไม่พบการดำเนินงาน KRC-20 สำหรับที่อยู่นี้ในช่วงเวลาที่เลือก',
      failed: 'ไม่สามารถโหลดการดำเนินงาน KRC-20 ได้: {error}',
      retry: 'ลองอีกครั้ง',
    },
  },
  languageNames: {
    en: 'EN',
    id: 'ID',
    fr: 'FR',
    zh_CN: '简体中文',
    zh_TW: '繁體中文',
    es: 'ES',
    th: 'TH',
  },
};

export default th;
